// extracted by mini-css-extract-plugin
module.exports = {"close-icon":"PortalDatabaseViewer_close-icon__1lzdn","header-portal-viewer":"PortalDatabaseViewer_header-portal-viewer__zX3ek","help-icon":"PortalDatabaseViewer_help-icon__Vi-m8"};